import gql from "graphql-tag";

export default gql`

  fragment SessionFragment on Session {
    id
    progress
    lastUpdate
    sessionGroup
    VersionSelected {
      id
      codec
      role
    }
    SubtitleSelected {
      id
    }
    Media {
      id
      duration
      Subtitle {
        id
        language
        offset
      }
    }
  }

`
